export const CALENDAR_DATE_REGEX = /^\d{4}-\d{2}-\d{2}$/;
export const DATE_TIME_REGEX =
  /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}(?::\d{2}(?:\.\d{3})?)?(?:Z|[+-]\d{2}:\d{2})$/;
